module.exports = __webpack_public_path__ + "img/C.83985c32.jpg";